// extracted by mini-css-extract-plugin
export default {"root":"NumericalDisplay_root__33JXD"};